import {
  NOTIFICATION_SETTINGS_SCREEN_URL,
  NOTIFICATIONS_SCREEN_URL,
  REQUEST_HISTORY_SCREEN_URL,
  URL_DASHBOARD,
} from "@/constants/urls";

export const TABS = [
  { label: "Իմ տվյալները", to: URL_DASHBOARD },
  { label: "Փոստարկղ", to: NOTIFICATIONS_SCREEN_URL },
  { label: "Հարցումներ իմ մասին", to: REQUEST_HISTORY_SCREEN_URL },
  // { label: "Կարգավորումներ", to: NOTIFICATION_SETTINGS_SCREEN_URL, chevron: true },
];

function matchesSection(pathname, basePath) {
  return pathname === basePath || pathname.startsWith(`${basePath}/`);
}

export function isTabActive(pathname, to) {
  // if (to === NOTIFICATION_SETTINGS_SCREEN_URL) {
  //   return matchesSection(pathname, NOTIFICATION_SETTINGS_SCREEN_URL);
  // }
  if (to === NOTIFICATIONS_SCREEN_URL) {
    return (
      matchesSection(pathname, NOTIFICATIONS_SCREEN_URL) &&
      !matchesSection(pathname, NOTIFICATION_SETTINGS_SCREEN_URL)
    );
  }
  if (to === REQUEST_HISTORY_SCREEN_URL) {
    return matchesSection(pathname, REQUEST_HISTORY_SCREEN_URL);
  }
  return (
    !matchesSection(pathname, NOTIFICATIONS_SCREEN_URL) &&
    !matchesSection(pathname, REQUEST_HISTORY_SCREEN_URL)
  );
}
